import { defer } from 'react-router-dom';
import { throttle } from '@utils/general.ts';
import authenticationService, {
  type User,
} from '@src/api/services/AuthenticationService.ts';

export interface ProfileLoaderData {
  profile: User;
  isContactInJob: boolean;
}

async function getData(): Promise<ProfileLoaderData> {
  await throttle();
  const profile = await authenticationService.getCurrentUser();
  const isContactInJob = await authenticationService.isContactInJob(profile.id);
  return {
    profile,
    isContactInJob,
  };
}

export const profileViewLoader = () => {
  return defer({ data: getData() });
};
